const ELLIPSIS = '…';

// Cuts the text after `maxLength` characters and appends an ellipsis, only when the text is longer than the limit
export const truncateText = (text: string, maxLength: number) =>
  text.length > maxLength ? `${text.substring(0, maxLength).trimEnd()}${ELLIPSIS}` : text;
